/**
 * A medida da linha, que é a diferença entre ler e varrer.
 *
 * Medido no navegador em 04/09/2026: o comentário ocupava a largura inteira do
 * conteúdo, **~120 caracteres por linha a 1440px** - e num monitor de 1920
 * passava de 150. Para leitura corrida o confortável é 65 a 80, e o módulo
 * inteiro existe para ler prosa longa.
 *
 * `ch` e não pixel: a medida é de caracteres, e acompanha o tamanho da fonte
 * que o leitor escolher.
 */
export const MEDIDA_DE_LEITURA = '72ch';

/**
 * A anotação de vigência, que o compilado imprime dentro do dispositivo.
 *
 * Sai da **exibição** e não do acervo: lá ela é o sinal de vigência legível por
 * máquina (D-25) e o que o verificador compara. Aqui ela se repetia em cada
 * inciso no mesmo peso do texto legal - cinco vezes no art. 4º do Código Civil,
 * num artigo de seis linhas.
 *
 * O `(Vigência)` e o `(Vide ADIN 4815)` saem junto: são links da página do
 * Planalto que aqui não levam a lugar nenhum.
 *
 * **O `(Revogado)` fica, e a distinção é a que importa.** Ele parece anotação e
 * é o **texto** do dispositivo: o art. 10, inciso III do Código Civil é
 * `III - (Revogado pela Lei nº 12.010, de 2009)`, e tirá-lo deixaria `III -`
 * sozinho na tela - o aluno leria um inciso em branco onde a lei diz que o
 * inciso caiu.
 */
const ANOTACAO_NO_TEXTO =
  /\s*\((?:Reda[çc][ãa]o dada|Inclu[íi]d[oa]|Acrescentad[oa]|Renumerad[oa]|Vig[êe]ncia|Vide)[^)]*\)/gi;

/**
 * Tira a anotação, **a menos que ela seja tudo o que há**.
 *
 * Dispositivo cujo texto inteiro é a anotação existe, e apagá-lo deixaria o
 * endereço na tela sem uma palavra embaixo. Na dúvida, mostrar o que a fonte
 * traz é o lado certo de errar.
 */
export function semAnotacao(texto: string): string {
  const limpo = texto.replace(ANOTACAO_NO_TEXTO, '').trimEnd();
  return limpo.replace(/^[^\p{L}\p{N}]+$/u, '') === '' ? texto : limpo;
}
